'use client';

import { Slot } from '@radix-ui/react-slot';
import { forwardRef, useMemo } from 'react';

import { css, cx } from '@/styled-system/css';

import { PropertyCardRootContext } from './context/property-card-root.context';
import { propertyCardRootRecipe } from './styles/property-card-root.styles';
import type { PropertyCardRootPropsInterface } from './types/property-card-root.types';

/**
 * @since 10.0.0
 */
export const PropertyCardRoot = forwardRef<HTMLElement, PropertyCardRootPropsInterface>(
  (props: PropertyCardRootPropsInterface, forwardedRef) => {
    const {
      appearance = 'large',
      asChild = false,
      children,
      className,
      css: cssProp,
      loading = false,
      ...rest
    } = props;

    const styles = css(propertyCardRootRecipe.raw({ appearance }), cssProp);

    const Component = asChild ? Slot : 'article';

    const contextValue = useMemo(() => ({ appearance, loading }), [appearance, loading]);

    return (
      <PropertyCardRootContext.Provider value={contextValue}>
        <Component
          ref={forwardedRef}
          data-c11n-component="PropertyCard.Root"
          data-c11n-version={__C11N_VERSION__}
          className={cx('c11n', styles, className)}
          {...rest}
        >
          {children}
        </Component>
      </PropertyCardRootContext.Provider>
    );
  },
);

PropertyCardRoot.displayName = 'PropertyCard.Root';
